export default {
  CorrelationByComplexity: 0,
  ManualImportOfTotalEnergy: 1,
  ManualImportOfMovedTons: 2
}